<app-modal [title]="dictionaryService.get('EditCustomer') || 'Edit Customer'" [(opened)]="modalOpened" size="lg"
    [loading]="!isDropdownDataReady()"
    [loadError]="dropdownCache.hasAnyError()"
    (closeTrigger)="handleModalClose()">

    @if (modalOpened()) {
    <div class="modal-content-wrapper">
        <div class="modal-scrollable-content">
            <form [formGroup]="editForm" (ngSubmit)="submit()" class="modal-form">

                <div class="form-grid">
                    <!-- Name Input -->
                    <div class="input-group">
                        <span class="input-label">{{ dictionaryService.get('Name') || 'Name' }}</span>
                        <app-input type="text" formControlName="name"
                            [placeholder]="dictionaryService.get('EnterName') || 'Enter name'" size="md"
                            name="name"></app-input>
                    </div>

                    <!-- Email Input -->
                    <div class="input-group">
                        <span class="input-label">{{ dictionaryService.get('Email') || 'Email' }}</span>
                        <app-input type="text" formControlName="email"
                            [placeholder]="dictionaryService.get('EnterEmail') || 'Enter email'" size="md"
                            name="email" [isError]="isEmailInvalid()"></app-input>
                        @if (isEmailInvalid()) {
                        <span class="field-error">{{ dictionaryService.get('InvalidEmailWithExample') || 'Please enter a valid email address. Example: name@example.com' }}</span>
                        }
                    </div>

                    <!-- Phone Input -->
                    <div class="input-group">
                        <span class="input-label">{{ dictionaryService.get('Phone') || 'Phone' }}</span>
                        <app-input type="text" formControlName="phone"
                            [placeholder]="dictionaryService.get('EnterPhone') || 'Enter phone'" size="md"
                            name="phone"></app-input>
                    </div>

                    <!-- Class Type Select -->
                    <div class="input-group">
                        <span class="input-label">{{ dictionaryService.get('ClassType') || 'Class' }}</span>
                        <app-select [options]="dropdownCache.classOptions()"
                            [placeholder]="dictionaryService.get('SelectClassType') || 'Select class type'"
                            [isFullWidth]="true" [disableSearch]="true" [defaultOption]="selectedClassType()"
                            (getSelectedOption)="onClassTypeChange($event)"></app-select>
                    </div>

                    <!-- Market Class Select -->
                    <div class="input-group">
                        <span class="input-label">{{ dictionaryService.get('MktClass') || 'MKT Class' }}</span>
                        <app-select [options]="dropdownCache.classOptions()"
                            [placeholder]="dictionaryService.get('SelectMktClass') || 'Select MKT class'"
                            [isFullWidth]="true" [disableSearch]="true" [defaultOption]="selectedMktClass()"
                            (getSelectedOption)="onMktClassChange($event)"></app-select>
                    </div>

                    <!-- Special Class Select -->
                    <div class="input-group dropdown-upward">
                        <span class="input-label">{{ dictionaryService.get('SpecialClass') || 'Special Class' }}</span>
                        <app-select [options]="dropdownCache.classOptions()"
                            [placeholder]="dictionaryService.get('SelectSpecialClass') || 'Select special class'"
                            [isFullWidth]="true" [disableSearch]="true" [defaultOption]="selectedSpecialClass()"
                            (getSelectedOption)="onSpecialClassChange($event)"></app-select>
                    </div>

                    <!-- Speciality Select -->
                    <div class="input-group">
                        <span class="input-label">{{ dictionaryService.get('Speciality') || 'Speciality' }}</span>
                        <app-select [options]="dropdownCache.specialityOptions()"
                            [placeholder]="dictionaryService.get('SelectSpeciality') || 'Select speciality'"
                            [isFullWidth]="true" [disableSearch]="false" [defaultOption]="selectedSpeciality()"
                            (getSelectedOption)="onSpecialityChange($event)"></app-select>
                    </div>

                    <!-- Type Select -->
                    <div class="input-group">
                        <span class="input-label">{{ dictionaryService.get('Type') || 'Type' }}</span>
                        <app-select [options]="typeOptions()"
                            [placeholder]="dictionaryService.get('SelectType') || 'Select type'" [isFullWidth]="true"
                            [disableSearch]="true" [defaultOption]="selectedType()"
                            (getSelectedOption)="onTypeChange($event)"></app-select>
                    </div>

                    <!-- Center Input -->
                    <div class="input-group">
                        <span class="input-label">{{ dictionaryService.get('Center') || 'Center' }}</span>
                        <app-input type="text" formControlName="center"
                            [placeholder]="dictionaryService.get('EnterCenter') || 'Enter center'" size="md"
                            name="center"></app-input>
                    </div>

                    <!-- Country Select -->
                    <div class="input-group">
                        <span class="input-label">{{ dictionaryService.get('Country') || 'Country' }}</span>
                        <app-select [options]="dropdownCache.countryOptions()"
                            [placeholder]="dictionaryService.get('SelectCountry') || 'Select country'"
                            [isFullWidth]="true" [disableSearch]="true" [defaultOption]="selectedCountry()"
                            (getSelectedOption)="onCountryChange($event)"></app-select>
                    </div>

                    <!-- Province Select -->
                    <div class="input-group" [class.disabled]="isProvinceDisabled()">
                        <span class="input-label">{{ dictionaryService.get('Province') || 'Province' }}</span>
                        <app-select [options]="dropdownCache.provinceOptions()"
                            [placeholder]="dictionaryService.get('SelectProvince') || 'Select province'"
                            [isFullWidth]="true" [disableSearch]="false" [defaultOption]="selectedProvince()"
                            (getSelectedOption)="onProvinceChange($event)"></app-select>
                    </div>

                    <!-- City Select -->
                    <div class="input-group" [class.disabled]="isCityDisabled()">
                        <span class="input-label">{{ dictionaryService.get('City') || 'City' }}</span>
                        <app-select [options]="cityOptions()"
                            [placeholder]="dictionaryService.get('SelectCity') || 'Select city'" [isFullWidth]="true"
                            [disableSearch]="false" [defaultOption]="selectedCity()"
                            (getSelectedOption)="onCityChange($event)"></app-select>
                    </div>

                    <!-- Targeted Frequency Input -->
                    <div class="input-group">
                        <span class="input-label">{{ dictionaryService.get('TargetedFrequency') || 'Targeted frequency'
                            }}</span>
                        <app-input type="number" formControlName="targetedFrequency"
                            [placeholder]="dictionaryService.get('EnterTargetedFrequency') || 'Enter targeted frequency'"
                            size="md" name="targetedFrequency" [isError]="isTargetedFrequencyInvalid()"></app-input>
                        @if (isTargetedFrequencyInvalid()) {
                        <span class="field-error">{{ dictionaryService.get('InvalidTargetedFrequency') || 'Targeted frequency must be at least 0.' }}</span>
                        }
                    </div>
                </div>
            </form>
        </div>

        <!-- Footer Buttons -->
        <div class="modal-footer">
            <button type="button" buttonTheme="light" buttonType="regular" size="rg" (click)="handleModalClose()"
                class="cancel-btn">
                {{ dictionaryService.get('Cancel') }}
            </button>
            <button type="button" buttonTheme="primary" buttonType="regular" size="rg" (click)="submit()"
                [disabled]="!isFormValid() || isSubmitting()">
                {{ dictionaryService.get('SaveChanges') || 'Save Changes' }}
            </button>
        </div>
    </div>
    }
</app-modal>
